import type { LucideIcon } from "lucide-react";
import { Megaphone, TrendingUp, Users, WalletMinimal } from "lucide-react";

/**
 * Static content for the "Organisme de formation" landing page.
 * Kept in one place so copy and options stay easy to review and translate.
 */

/** Options for the "Vous représentez" select. */
export const REPRESENTE_OPTIONS: { value: string; label: string }[] = [
  { value: "centre-de-formation", label: "Un organisme de formation" },
  { value: "organisme-de-formation", label: "Un établissement d'enseignement supérieur" },
  { value: "formateur-independant", label: "Un apprenant" },
  { value: "entreprise", label: "Un formateur indépendant" },
  { value: "autre", label: "Autre" },
];

/** Short value-proposition bullets shown next to the form in the hero. */
export const HERO_HIGHLIGHTS: string[] = [
  "Diffusez gratuitement votre catalogue de formations",
  "Recevez les coordonnées de leads qualifiés",
  "Ne payez que pour les leads que vous recevez",
];

export interface Benefit {
  icon: LucideIcon;
  title: string;
  description: string;
}

/** Benefit cards shown in the showcase section next to the presentation video. */
export const BENEFITS: Benefit[] = [
  {
    icon: Megaphone,
    title: "Un catalogue mis en avant",
    description:
      "Publiez gratuitement vos formations et bénéficiez d'une mise en avant automatique sur Spot Formation.",
  },
  {
    icon: TrendingUp,
    title: "La visibilité de notre trafic",
    description:
      "Profitez de l'audience de la plateforme pour toucher chaque mois des milliers d'apprenants motivés.",
  },
  {
    icon: Users,
    title: "Des leads qualifiés",
    description:
      "Recevez les coordonnées de prospects filtrés et réellement intéressés par vos formations.",
  },
  {
    icon: WalletMinimal,
    title: "Une facturation à la performance",
    description:
      "Aucun abonnement : vous ne réglez que les leads que vous recevez, en toute transparence.",
  },
];

/** Example organisation used to preview how a center appears on Spot Formation. */
export const PREVIEW_CENTER = {
  name: "Votre organisme de formation",
  logoUrl: "/assets/naxis-logo.png",
  siret: "123 456 789 00000",
  accreditationNumber: "00-0000-00000",
  accessibility: "Accessibilité PMR disponible — Accès Handicap 01",
} as const;
